import { render, staticRenderFns } from "./FiltersContainer.vue?vue&type=template&id=22bc2965&lang=pug&"
import script from "./FiltersContainer.vue?vue&type=script&lang=ts&"
export * from "./FiltersContainer.vue?vue&type=script&lang=ts&"
import style0 from "./FiltersContainer.vue?vue&type=style&index=0&id=22bc2965&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports